import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Marcela G.',
  location: 'Buenos Aires · Docente de primaria',
  quote: 'Llegué a la reunión de padres sin saber cómo arrancar. Con el Módulo 4 tuve el taller completo listo en 24 horas. Las familias se fueron con materiales y compromisos concretos.',
  initials: 'MG'
}, {
  name: 'Roberto P.',
  location: 'Córdoba · Director de escuela primaria',
  quote: 'El Módulo 1 me dio el respaldo legal que necesitaba para hablar con los padres de un caso de bullying sin miedo a decir algo incorrecto.',
  initials: 'RP'
}, {
  name: 'Valeria S.',
  location: 'Rosario · Orientadora del EOE',
  quote: 'Por fin un material que habla en argentino, con leyes argentinas y situaciones reales de nuestras escuelas. Lo usé la semana siguiente de comprarlo.',
  initials: 'VS'
}, {
  name: 'Daniela M.',
  location: 'Mendoza · Maestra de 5° grado',
  quote: 'Las actividades del Módulo 2 son un regalo. Los chicos participaron y al final firmaron su propio acuerdo de convivencia. Nunca los vi tan comprometidos.',
  initials: 'DM'
}, {
  name: 'Claudia L.',
  location: 'La Plata · Vice-directora de primaria',
  quote: 'Los stickers y separadores cambiaron el clima del aula en dos semanas. Los chicos se esfuerzan para ganarlos y se cuidan entre ellos.',
  initials: 'CL'
}];
export function Testimonials() {
  return <section className="bg-[#FFFEF7] py-6 md:py-12 lg:py-[60px]" data-id="element-208">
      <div className="container mx-auto px-4" data-id="element-209">
        <h2 className="text-[#1B3A6B] font-poppins font-bold text-3xl md:text-5xl text-center mb-5 md:mb-6 lg:mb-8" data-id="element-210">
          ❤️ LO QUE DICEN QUIENES YA LO USAN
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-3 md:gap-5 max-w-6xl mx-auto" data-id="element-211">
          {testimonials.slice(0, 4).map((t, i) => <TestimonialCard key={i} {...t} data-id="element-212" />)}
        </div>
        <div className="mt-3 md:mt-5 flex justify-center" data-id="element-213">
          <div className="max-w-3xl w-full" data-id="element-214">
            <TestimonialCard {...testimonials[4]} data-id="element-215" />
          </div>
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  name,
  location,
  quote,
  initials
}: any) {
  return <div className="bg-white p-4 md:p-6 rounded-[16px] shadow-[0_2px_20px_rgba(0,0,0,0.08)] flex flex-col h-full" data-id="element-216">
      <div className="flex gap-1 mb-3" data-id="element-217">
        {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="#FFD700" color="#FFD700" data-id="element-218" />)}
      </div>
      <p className="text-[#2C2C2C] italic mb-4 md:mb-6 flex-grow leading-relaxed" data-id="element-219">
        "{quote}"
      </p>
      <div className="flex items-center gap-3" data-id="element-220">
        <div className="w-12 h-12 bg-[#1B3A6B] rounded-full flex items-center justify-center text-white font-bold" data-id="element-221">
          {initials}
        </div>
        <div data-id="element-222">
          <p className="text-[#1B3A6B] font-poppins font-bold" data-id="element-223">{name}</p>
          <p className="text-[#555555] text-sm" data-id="element-224">{location}</p>
        </div>
      </div>
    </div>;
}